import type { Player } from '@schibsted-svp/web-player';

export function getPlayerAspectRatio(player?: Player) {
  const rect = player?.getContainer()?.getBoundingClientRect();
  if (!rect || rect.height < 2) return undefined;
  return rect.width / rect.height;
}
